export enum UNITS {
  GRAMS = "g",
  KILO = "kg",
  TON = "ton",
  LITER = "l",
  MILLILITER = "ml",
  PERCENT = "%",
  KR = ":-",
  CUBIC = "m³",
  KWH = "kWh",
  ROI = "ROI",
  PER_UNIT = "st",
  KILO_PER_KWH = "kg/kWh",
  KILO_PER_CUBIC = "kg/m³",
}
